<template>
  <div class="pt-4 px-0 mt-10" id="contact-us">
    <div class="landing-light-orange">
      <div
        class="max-w-7xl mx-auto flex flex-col sm:flex-row gap-4 sm:gap-0 items-center justify-between rounded-t-md px-4 py-4"
      >
        <div class="max-w-32 md:max-w-fit">
          <NuxtLink to="/" aria-label="Ana Sayfa">
            <NuxtImg
              src="/img/logo/360-sosyal-logo.svg"
              alt="360 Sosyal"
              width="200"
              height="60"
            />
          </NuxtLink>
        </div>
        <NuxtLink
          href="mailto:info@360sosyal.com"
          class="text-white text-sm md:text-md"
          aria-label="E-posta Gönder"
        >
          <div class="flex flex-row items-center bg-orange-500 rounded p-2">
            <Icon
              name="material-symbols:mail"
              class="size-5 md:size-6 text-white mr-2"
            />
            <div
              style="background-color: white; min-width: 2px; min-height: 2rem"
            ></div>
            <span class="ml-2"> info@360sosyal.com </span>
          </div>
        </NuxtLink>
      </div>
    </div>
    <div class="border-t-4 border-t-orange-500"></div>
    <footer class="w-full bg-white py-6 px-3 md:px-5">
      <div class="max-w-7xl mx-auto">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
          <div>
            <h2 class="text-lg font-extrabold text-orange-500">
              Kurumsal Bilgiler
            </h2>
            <div
              class="footer-sticks flex flex-row flex-nowrap items-center h-6"
            >
              <div></div>
              <div></div>
            </div>
            <div class="flex flex-col gap-1">
              <div class="">
                <span class="text-sm text-orange-500 font-bold mr-1">
                  Unvan:
                </span>
                <span class="text-sm text-slate-800"
                  >GİGDATA BİLGİ TEKNOLOJİLERİ LİMİTED ŞİRKETİ</span
                >
              </div>
              <div>
                <span class="text-sm text-orange-500 font-bold mr-1">
                  Adres:
                </span>
                <span class="text-sm text-slate-800"
                  >Yahyakaptan Mah. Akasyalar Cd. No:24/1 Arastapark AVM B Blok
                  Kat: 2 Daire: 12 İzmit/Kocaeli</span
                >
              </div>
              <div>
                <span class="text-sm text-orange-500 font-bold mr-1">
                  Telefon:
                </span>
                <span class="text-sm text-slate-800">+90 850 346 0778</span>
              </div>
            </div>
          </div>
          <div>
            <h2 class="text-lg font-extrabold text-orange-500">Sözleşmeler</h2>
            <div
              class="footer-sticks flex flex-row flex-nowrap items-center h-6"
            >
              <div></div>
              <div></div>
            </div>
            <div class="flex flex-col gap-1">
              <template v-for="(item, index) in contracts" :key="index">
                <NuxtLink target="_blank" :to="item.path">
                  <Icon
                    name="icon-park-solid:right-c"
                    class="text-orange-500 mr-2"
                  />
                  <span
                    class="text-sm text-slate-800 hover:text-orange-500 transition-all duration-200 cursor-pointer"
                  >
                    {{ item.name }}
                  </span>
                </NuxtLink>
              </template>
            </div>
          </div>
          <div class="col-span-2 mt-4 md:mt-0">
            <h2 class="text-lg font-extrabold text-orange-500">
              Sosyal Medyada Biz
            </h2>
            <div
              class="footer-sticks flex flex-row flex-nowrap items-center h-6"
            >
              <div></div>
              <div></div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
              <template v-for="(social, index) in socials" :key="index">
                <NuxtLink
                  :href="social.path"
                  target="_blank"
                  :aria-label="`360sosyal ${social.name} Hesabı Linki`"
                >
                  <div
                    class="flex items-center bg-orange-500 rounded-md relative p-2"
                  >
                    <div
                      class="rounded-md p-1"
                      style="background-color: #ffa668"
                    >
                      <Icon
                        :name="social.icon"
                        class="size-5 md:size-6 text-white"
                      />
                    </div>
                    <span
                      class="font-semibold text-white text-sm md:text-md ml-2"
                    >
                      {{ social.name }}
                    </span>
                    <span
                      class="font-extralight text-white text-sm md:text-md pl-1"
                    >
                      Adresimiz
                    </span>
                    <Icon
                      name="tabler:arrow-up-right"
                      class="size-5 text-white absolute right-2"
                    />
                  </div>
                </NuxtLink>
              </template>
            </div>
            <div class="mt-4 flex flex-wrap items-center gap-3">
              <NuxtImg
                src="/img/icons/banking/visa-text-dark.svg"
                alt="Visa"
                width="56"
                height="18"
                class="h-5 w-auto"
              />
              <NuxtImg
                src="/img/icons/banking/mastercard-text-dark.svg"
                alt="Mastercard"
                width="84"
                height="18"
                class="h-7 w-auto"
              />
              <NuxtImg
                src="/img/icons/banking/troy.svg"
                alt="Troy"
                width="60"
                height="18"
                class="h-7 w-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
    <div class="bg-orange-500 text-center p-4">
      <span class="text-white text-sm font-medium">
        Copyright © {{ currentYear }} Tüm hakları saklıdır.
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
const socials = ref([
  {
    name: "Youtube",
    path: "https://www.youtube.com/360sosyal",
    icon: "mdi:youtube",
  },
  {
    name: "Linkedin",
    path: "https://www.linkedin.com/",
    icon: "mdi:linkedin",
  },
  {
    name: "Instagram",
    path: "https://instagram.com/360sosyal",
    icon: "mdi:instagram",
  },
  { name: "X", path: "https://www.x.com/360sosyal", icon: "prime:twitter" },
])

const contracts = ref([
  { name: "KVKK Politikası", path: "/pages/360Sosyal-KVKK-Politikasi" },
  {
    name: "KVKK Aydınlatma Metni",
    path: "/pages/360Sosyal-KVKK-Aydinlatma-Metni",
  },
  {
    name: "Kullanıcı Sözleşmesi",
    path: "/pages/360Sosyal-Kullanici-Sozlesmesi",
  },
  { name: "Gizlilik Politikası", path: "/pages/360Sosyal-Gizlilik-Politikasi" },
  { name: "Çerez Politikası", path: "/pages/360Sosyal-Cerez-Politikasi" },
  { name: "Açık Rıza Metni", path: "/pages/360Sosyal-Acik-Riza-Metni" },
  {
    name: "Garanti, İptal ve İade Sözleşmesi",
    path: "/pages/360Sosyal-Iptal-Iade",
  },
])

const currentYear = new Date().getFullYear()
</script>

<style scoped>
.footer-sticks {
  div:nth-child(1) {
    width: 60px;
    height: 3px;
    background-color: #f97316;
  }
  div:nth-child(2) {
    width: 40px;
    height: 2px;
    background-color: #f97316;
    opacity: 0.5;
  }
}
</style>
